import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";

function Search({ products, setProducts,searchInput}) {
  //search Logic
  const [searchQuery, setSearchQuery] = useState("");
 
  useEffect(() => {
    setSearchQuery(searchInput || "");
  },[searchInput])

  // Event handler to update the search query
  const handleSearchInputChange = (event) => {
    if (event.target.value === "") {
      setProducts(products);
    }
    setSearchQuery(event.target.value);
  };

  // Function to filter products based on search query
  const filterProductList = () => {
    const lowerCaseQuery = searchQuery.toLowerCase().trim();
    // const filtered = products.filter(product =>
    //     product.name.toLowerCase().includes(lowerCaseQuery)
    // );
    const filtered = products.filter((product) =>
      JSON.stringify(product).toLowerCase().includes(lowerCaseQuery)
    );
    setProducts(filtered);
  };

  // Event handler to handle Enter key press
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      filterProductList();
    }
  };

  return (
    <div className="py-6 p-2 pt-8 w-full search-container container">
      <div className="flex justify-between item-center px-4 p-2 border search-box">
        <input
          className="shadow-none m-0 p-0 border-none w-[80%] outline-none"
          type="text"
          placeholder="Search for products in this collection"
          value={searchQuery}
          onChange={handleSearchInputChange}
          onKeyDown={handleKeyPress}
        />
        <FiSearch
          className="text-primary text-xl hover:text-black cursor-pointer"
          onClick={filterProductList}
        />
      </div>
    </div>
  );
}

export default Search;
